import(/* webpackMode: "eager" */ "/root/db6/admin/src/app/not-found.tsx");
